/****************************************************
 * Module Name:  userColumnPermissionProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/


import restAPICall from "../../../api/restAPICall";
import Constants from "../../../constants";

export default class UserColumnPermissionProxy {

  static GetAllPermissionForSingleUser = (userId, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/columnpermission/${userId}`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllColumnPermission = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/columnpermission`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllColumnPermissionMap = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/columnpermission/map`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  }

  static GrantPermission = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/columnpermission/grant",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static RevokePermission = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/columnpermission/revoke",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GrantPermissionToVirtualTeam = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/columnpermission/virtualteam/grant",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static RevokePermissionFromVirtualTeam = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/columnpermission/virtualteam/revoke",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetUserByColumnPermission = (data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + "/columnpermission/users",
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetColumnNameForUser = (userId, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/columnpermission/columnname/${userId}`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static ColumnOrderSequence = (userId, data, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/columnpermission/columnordersequence/${userId}`,
      "post",
      Constants.userToken,
      undefined,
      JSON.stringify(data),
      "application/json",
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetPermissionsForUserInSequence = (userId, callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/columnpermission/columnordersequence/${userId}`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

  static GetAllColumnPermissionMini = (callback) => {
    restAPICall(
      Constants.MANAGER_URL + `/columnpermission/mini`,
      "get",
      Constants.userToken,
      undefined,
      undefined,
      undefined,
      0
    )
      .then((response) => callback(response))
      .catch((error) => {
        callback(undefined);
      });
  };

}